var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '@web/utility';
export function Avatar(_a) {
    var _b;
    var src = _a.src, _c = _a.alt, alt = _c === void 0 ? '' : _c, _d = _a.height, height = _d === void 0 ? 32 : _d, _e = _a.width, width = _e === void 0 ? 32 : _e, _f = _a.className, className = _f === void 0 ? '' : _f, _g = _a.text, text = _g === void 0 ? '' : _g, _h = _a.textClassName, textClassName = _h === void 0 ? '' : _h;
    return src ? (_jsx("div", __assign({ className: "relative inline-block", style: {
            width: "".concat(width, "px"),
            height: "".concat(height, "px")
        } }, { children: _jsx("img", { className: classNames('rounded-full ring-2 ring-white relative inline-flex items-center justify-center overflow-hidden', className), src: src, alt: alt, style: {
                minWidth: "".concat(width, "px"),
                minHeight: "".concat(height, "px")
            }, height: "".concat(height, "px"), width: "".concat(width, "px") }) }))) : (_jsx("div", __assign({ className: "relative" }, { children: _jsx("div", __assign({ className: classNames('relative inline-flex items-center justify-center overflow-hidden bg-gray-100 rounded-full dark:bg-gray-600 ', className, !width && !height ? 'w-10 h-10' : ''), style: {
                width: "".concat(width, "px"),
                height: "".concat(height, "px")
            } }, { children: _jsx("span", __assign({ className: classNames('text-gray-600 dark:text-gray-300', textClassName) }, { children: ((_b = text[0]) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || '' })) })) })));
}
export default Avatar;
